<template>
  <div class="contact-page">
    <ContactHeader />
    <section class="contact-content">
      <div class="container">
        <ContactForm />
        <ContactFaq />
      </div>
    </section>
  </div>
</template>

<script>
import ContactHeader from '../sections/contattaci/ContactHeader.vue'
import ContactForm from '../sections/contattaci/ContactForm.vue'
import ContactFaq from '../sections/contattaci/ContactFaq.vue'

export default {
  name: 'Contattaci',
  components: {
    ContactHeader,
    ContactForm,
    ContactFaq
  }
}
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #1e3c72 0%, #f9fafb 20%);
}

.contact-content {
  padding: 80px 0 100px;
  background: transparent;
}

@media (max-width: 768px) {
  .contact-content {
    padding: 60px 0 80px;
  }
}
</style>


